import { HorseRaceWagerType } from "@freeplay/shared-code";
import React from "react";
import { ButtonSize, ButtonTheme, RoundedButton } from "../../components/buttons/roundedButton/RoundedButton";
import { useEvent } from "../../contexts/EventContext";
import { useServices } from "../../contexts/ServiceContext";
import { GameActions, GameState } from "../../controllers/GameController";

type RandomButtonProps = {
    state: GameState;
    dispatch: React.Dispatch<GameActions>;
};

export const RandomButton = ({ state, dispatch }: RandomButtonProps): JSX.Element => {
    const { edgeDeploy } = useServices();
    const { currentEvent } = useEvent();
    const { randomButtonPressed } = state;

    if (!currentEvent) {
        return <></>;
    }
    const handleRandomButtonPressed = () => {
        if (currentEvent.horseRacingPrompts.length !== 0) {
            const choices = [...state.horseRaceChoices];
            let count = 0;
            for (const horseRacePrompt of currentEvent.horseRacingPrompts) {
                const pick = {
                    choices: [0],
                };

                if (horseRacePrompt.propType === HorseRaceWagerType.PICKEM) {
                    const howMany = horseRacePrompt.pickEm;
                    const pickEmRand = [];
                    const pickSelectionHorsesIds = [];

                    while (pickEmRand.length < howMany) {
                        const val = Math.floor(Math.random() * horseRacePrompt.horseRaceEvent.horseData.length);
                        if (pickEmRand.indexOf(val) === -1) {
                            pickEmRand.push(val);
                            pickSelectionHorsesIds.push(horseRacePrompt.horseRaceEvent.horseData[val].programNumber);
                        }
                    }
                    pick.choices = pickSelectionHorsesIds;
                    choices[count] = pick;
                    count++;
                } else if (
                    horseRacePrompt.propType === HorseRaceWagerType.HORSETOWIN ||
                    horseRacePrompt.propType === HorseRaceWagerType.TOP4
                ) {
                    const rand = Math.random();
                    if (rand < 0.5) {
                        pick.choices = [0];
                        choices[count] = pick;
                        count++;
                    } else {
                        pick.choices = [1];
                        choices[count] = pick;
                        count++;
                    }
                }
                //at last we will need random values for winning time and distance
                else {
                    const rand = Math.floor(Math.random() * 3);
                    if (rand === 0) {
                        pick.choices = [0];
                        choices[count] = pick;
                        count++;
                    }
                    if (rand === 1) {
                        pick.choices = [1];
                        choices[count] = pick;
                        count++;
                    }
                    if (rand === 2) {
                        pick.choices = [-1];
                        choices[count] = pick;
                        count++;
                    }
                }
            }
            dispatch({ type: "setHorseRaceChoices", horseRaceChoices: choices });
            dispatch({ type: "setButtonState", random: true, favourites: false });
        } else {
            const choices = [...state.choices];
            let count = 0;
            for (const platformEvent of currentEvent.platformEvents) {
                for (const platformOffer of platformEvent.platformOffers) {
                    const randomNumber = Math.floor(Math.random() * 2);
                    const currentPick = {
                        platformEventId: platformOffer.platformEvent,
                        platformOfferId: platformOffer.platformOutcomes[randomNumber].platformOffer,
                        platformOutcomeId: platformOffer.platformOutcomes[randomNumber].id,
                    };
                    choices[count] = currentPick;
                    count++;
                }
            }
            dispatch({ type: "setChoices", choices });
            dispatch({ type: "setButtonState", random: true, favourites: false });
        }
    };

    return (
        <RoundedButton
            config={{
                buttonText: "Random",
                size: edgeDeploy ? ButtonSize.LARGE : ButtonSize.MEDIUM,
                theme: ButtonTheme.BASE,
                margin: { left: 5 },
                isActive: randomButtonPressed,
            }}
            testID={"random"}
            onPress={handleRandomButtonPressed}
        />
    );
};
